import { createSelectorFunctions, type ZustandFuncSelectors } from 'auto-zustand-selectors-hook';
import type { ExtractState, StoreApi } from 'zustand/vanilla';

export type StoreWithSelectors<Store extends StoreApi<object>> = Store &
  ZustandFuncSelectors<ExtractState<Store>>;

/**
 * Adds one hook per field to a vanilla store, `store.use.metadata()`, each subscribing the
 * component to that field only.
 */
export function withSelectors<Store extends StoreApi<object>>(store: Store) {
  // The library types its result as a bound hook store, but a vanilla store stays vanilla
  return createSelectorFunctions(store) as unknown as StoreWithSelectors<Store>;
}
